import { useOutletContext } from "react-router-dom";

import LocationStaff from "./locationStaff";
import useRoles from "../../hooks/useRoles";
import { getUserEnv } from "../../utils/authorization";
const SatffPage = () => {
  const { roles } = useRoles();
  console.log("User roles:", roles); // Debugging line to check roles
  if (roles.includes("Toca Manager")) {
    return <LocationStaff />;
  }
  if (roles.includes("Super User")) {
    return <LocationStaff />;
  }
  if (roles.includes("Account Admin")) {
    return <LocationStaff />;
  }
  if (getUserEnv() === "admin") {
    return <LocationStaff />;
  }
  
  if (roles.includes("Patient")) {
    return <h1>UnAuthorized access</h1>;
  }

  return <h1>UnAuthorized access</h1>;
};

export default SatffPage;
